export default __webpack_public_path__ + "a147eb4.png";